import React, { useState } from 'react';
import Form from 'global/components/form';
import { get, size } from '../../../global/lib/lodash';
import useStyles from './styles';
import { Column, Row } from '../../../global/components/row';
import { Button } from '../../../global/components/Button';
import { _size } from 'global/utils';
import sendData from 'redux/actions/sendData';
import SnackAlerts from '../../../global/components/snack-alerts';
import { fixMinus } from './create-scorecard';
import colors from 'global/styles/colors';
import { Text } from '../../../global/components/text'
import { RoomAssignmentsModal } from './room-assignments'
import { useScreen } from '../../../global/styles';

export const EditScorecard = (props) => {
  const classes = useStyles();
  const [alerts, setAlerts] = useState();
  const [fs, setfs] = useState({});
  const [state, setState] = useState({
    loading: false,
  });

  const { isMobileXS } = useScreen();

  const [rms, setRms] = useState({
    modalProps: {
      open: false,
      onClose: () => {
        setRms(s => ({ ...s, modalProps: { ...s.modalProps, open: false } }))
      }
    }
  })

  const [rlms, setRlms] = useState({
    modalProps: {
      open: false,
      onClose: () => {
        setRlms(s => ({ ...s, modalProps: { ...s.modalProps, open: false } }))
      }
    }
  })

  const onSubmit = async () => {
    try {
      setState((s) => ({ ...s, loading: true }));

      const scid = get(props, 'scorecard.id');

      const realms = get(fs, 'realms') ? (Array.isArray(fs.realms) ? fs.realms : Object.keys(fs.realms)).map(k => ({ type: 'realms', id: k.id || k })) : undefined;
      const userGroups = size(get(fs, 'userGroups')) ? fs.userGroups.map(id => ({ type: 'user-groups', id })) : undefined;

      const data = {
        data: {
          id: scid,
          type: 'scorecards',
          attributes: {
            ...fixMinus(fs),
            realms: undefined,
            userGroups: undefined,
          },
          relationships: {
            realms: realms ? { data: realms } : undefined,
            userGroups: userGroups ? { data: userGroups } : undefined,
          }
        },
      };

      const resp = await sendData({
        url: `/scorecards/${scid}`,
        method: 'patch',
        data,
      }, { simulate: false });

      props.onClose && props.onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    } finally {
      setState((s) => ({ ...s, loading: false }));
    }
  };

  const setupAssignmentsModal = () => {
    setRms(s => ({
      ...s,
      modalProps: {
        ...s.modalProps,
        open: true,
        title: () => {
          const COMP = isMobileXS ? p => <h6 {...p} /> : p => <span {...p} />;
          return COMP({ children: `Edit Room Assigments for ${get(props, 'scorecard.name')}` })
        },
      }
    }))
  }

  const setupRealmAssignmentsModal = () => {
    setRlms(s => ({
      ...s,
      modalProps: {
        ...s.modalProps,
        open: true,
        title: () => {
          const COMP = isMobileXS ? p => <h6 {...p} /> : p => <span {...p} />;
          return COMP({ children: `Edit Location Assigments for ${get(props, 'scorecard.name')}` })
        },
      }
    }))
  }

  const canShowEditRoomAssigments = (() => {
    const tiers = get(props, 'scorecard.config.allowedTiers');
    return !size(tiers) || tiers.includes('lot') ? true : false;
  })();

  const dropRealmProps = (() => {
    const edrealms = get(props, 'edition.realms', []);
    const isDivision = !!edrealms.find(r => r.tier === 'division');
    let disabled = isDivision;
    let allRealms;

    if (isDivision && size(edrealms) > 1) {
      disabled = false;
      allRealms = edrealms;
    }

    return {
      disabled,
      allRealms,
    }
  })();

  return (
    <div className={classes.createSc}>
      <Column center fullWidth>
        <div style={{ width: '100%', marginBottom: 34 }}>
          <Form
            onFormState={setfs}
            loading={state.loading}
            showAllScreens
            screens={[
              {
                title: 'General Information',
                inputs: [
                  {
                    id: 'name',
                    type: 'TextField',
                    defaultValue: () => get(props, 'scorecard.name', ''),
                    required: true,
                    props: {
                      label: 'Name',
                    },
                  },
                  {
                    id: 'active',
                    type: 'Select',
                    defaultValue: () => get(props, 'scorecard.active', 0) === 0 ? -1 : 1,
                    data: [
                      { value: 1, title: 'True' },
                      { value: -1, title: 'False' },
                    ],
                    props: {
                      label: 'Active',
                    },
                  },
                  {
                    id: 'realms',
                    type: 'DropRealms',
                    defaultValue: () => get(props, 'edition.realms', []).find(r => r.tier === 'division') ? get(props, 'edition.realms', []) : get(props, 'scorecard.realms', []),
                    props: {
                      label: 'Access',
                      placeholder: 'Edit Access',
                      useNewHist: true,
                      ...dropRealmProps,
                    },
                  },
                  {
                    id: 'userGroups',
                    type: 'Select',
                    data: get(props, 'userGroups', []),
                    item: (item) => ({ value: item.id, title: item.name }),
                    defaultValue: () => get(props, 'scorecard.userGroups', []).map(u => u.id),
                    props: {
                      label: 'User Groups',
                      multiple: true,
                    },
                  },
                ]
              }
            ]}
          />
          <div style={{ maxWidth: 640, margin: '0 auto' }}>
            <Button onClick={setupAssignmentsModal} icon="edit" title="EDIT ROOM ASSIGNMENTS" disabled={!canShowEditRoomAssigments} />
            {!canShowEditRoomAssigments && <Text type="label_small" italic>Room Assignments are only used in Lot-Level assessments, which are disabled for this scorecard</Text>}
          </div>
        </div>

        <Row center className={classes.buttonRowModal} style={{ justifyContent: 'center' }}>
          <Button icon="close" bgColor={colors.danger} onClick={() => props.onClose()}>
            CANCEL
          </Button>
          <Button disabled={!fs.name} icon="save" onClick={() => onSubmit()}>
            SAVE
          </Button>
        </Row>

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </Column>

      <RoomAssignmentsModal {...rms} scorecard={props.scorecard} />
    </div>
  );
};